import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { ObservationSectionPermissionsDTO } from 'src/app/model/observation/observation-section-permissions-dto.model';
import { ResourceData } from 'src/app/services/resource/resource.service';

@Component({
    selector: 'app-ntpe-section-one-goals',
    templateUrl: './section-one-goals.component.html',
    styleUrls: ['./section-one-goals.component.scss']
})
export class SectionOneGoalsComponent implements OnInit {
    @Input() readOnly: boolean = true;
    @Input() resourceFile?: ResourceData = {};
    @Input() permissions?: ObservationSectionPermissionsDTO;
    @Output() save = new EventEmitter<any>();
    @Output() continue = new EventEmitter<any>();
    @Output() feedback = new EventEmitter();

    public form!: UntypedFormGroup;

    constructor(private controlContainer: ControlContainer) { }

    ngOnInit(): void {
        this.form = <UntypedFormGroup>this.controlContainer.control;
    }

    onContinueClick = () => this.continue.emit();
    onSaveClick = (event: any) => this.save.emit(event);
    onFeedbackClick = () => this.feedback.emit();
}
